import { inject } from '@angular/core';
import { HttpErrorResponse, HttpResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, filter, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { CustomHeader } from '../models/header.enum';
import { AppService } from '../services/app.service';

export const errorCatchingInterceptor: HttpInterceptorFn = (req, next) => {
  const translate = inject(TranslateService);
  const appService = inject(AppService);
  let skipNotification = false;
  if (req.headers.has(CustomHeader.SkipNotificationHeader)) {
    req = req.clone({ headers: req.headers.delete(CustomHeader.SkipNotificationHeader) });
    skipNotification = true;
  }

  return next(req)
    .pipe(
      filter(event => event instanceof HttpResponse),
      tap(() => {
        if (!skipNotification) {
          switch (req.method) {
            case 'POST': appService.showMsg(translate.instant(`http.successfullyCreated`)); break;
            case 'PUT': appService.showMsg(translate.instant(`http.successfullyUpdated`)); break;
            case 'PATCH': appService.showMsg(translate.instant(`http.successfullyUpdated`)); break;
            case 'DELETE': appService.showMsg(translate.instant(`http.successfullyDeleted`)); break;
          }
        }
      }),

      catchError((error: HttpErrorResponse) => {
        if (skipNotification) {
          return throwError(() => error);
        }
        const errorDescription = typeof error.error === 'string'
          ? error.error
          : error.error?.description || error.error?.message || error.error?.Message || '';

        appService.showMsg(translate.instant(`http.error`, {
          errorTitle: translate.instant(`http.${error.error?.title || error.status}`),
          errorDescription,
        }), 'error');
        return throwError(() => error);
      }),

    );
}
